import { gql } from "@apollo/client";

export default gql`
  mutation deleteCallAdminLogs($params: DeleteCallAdminLogsInput!){
    deleteCallAdminLogs(params: $params){
        success
        data{
            deletedCount
        }
        code
        message
    }
}
`
